// extracted by mini-css-extract-plugin
module.exports = {"bar":"BottomTabs_bar___opS4","tab":"BottomTabs_tab__8b8mk","label":"BottomTabs_label__jPaa9","moreButton":"BottomTabs_moreButton__SDVW2"};